import React from "react";
import Context from "../../../Context";
import EssenceActionsDropdown from "../../Essence/EssenceActionsDropdown";
import EssenceStateLabel from "../../Essence/EssenceStateLabel";
import LibraryPdfView from "../../Essence/Library/LibraryPdfView";
import Blocker from "../../Misc/Blocker";
import CrumbsProvider from "../../Misc/CrumbsProvider";
import DefaultNotFound from "../../Misc/DefaultNotFound";
import Flex from "../../Misc/Flex";

export default class CertificateItem extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      item: null,
      files: [],
      singleFile: false,
    };
    this.link = document.createElement("a");
  }
  componentDidMount() {
    this.load();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.itemId !== this.props.itemId) {
      this.load();
    }
  }
  load = async () => {
    let item = {};
    let files = [];
    let singleFile = false;

    if (this.props.itemId) {
      this.setState({ pending: true });

      item = await this.context.api.q(`/certificate/get`, {
        id: this.props.itemId,
      });

      files = await this.context.api.qa("/object/file", {
        id: this.props.itemId,
      });

      if (files.length === 1) {
        let result = await this.context.api.q("/object/file/get", {
          id: this.props.itemId,
          name: files[0].name,
        });
        if (result) {
          if (result.name) {
            singleFile = result;
            singleFile.src = result.type + result.data;
            if (result.type === "data:application/pdf;base64,") {
              singleFile.isPdf = true;
            }
          }
        }
      }
    }

    this.setState({ pending: false, item, files, singleFile }, () =>
      this.context.force()
    );
  };

  download = async (file) => {
    this.setState({ pending: true });
    let result = await this.context.api.q("/object/file/get", {
      id: this.props.itemId,
      file
    });
    if (result !== false) {
      let data = result.type + result.data;
      this.link.setAttribute("href", data);
      this.link.setAttribute("download", result.name);
      this.link.setAttribute("target", "_blank");
      this.link.click();
      this.setState({ pending: false });
    } else {
      this.context.toast("Не удалось скачать файл", "error");
      this.setState({ pending: false });
    }
  };

  render() {
    const { item, pending } = this.state;
    const { rights } = this.props;

    const created = item ? new Date(item.created) : {};
    const lastupdate = item ? new Date(item.lastupdate) : {};
    const validtodate = item ? new Date(item.validtodate) : {};

    const filesList = this.state.files.map((file) => {
      file.date = new Date(file.date);
      file.loaded = new Date(file.loaded);

      return (
        <div
          key={`${file.name}${file.loaded}`}
          onClick={() => this.download(file.file)}
          className="py-2 font-size-lg cursor-pointer text-hover-primary d-flex align-items-center"
        >
          <i className="fa fa-file-o fa-2x mr-4"></i>
          {file.text}
        </div>
      );
    });

    return (
      <>
        <Blocker spinnerFixed hAuto on={pending}>
          {!item && this.props.itemId && !pending && <DefaultNotFound />}
          {item && (
            <>
              <CrumbsProvider title={item.label} />
              <div className="card card-custom mb-5">
                <div className="card-body">
                  <Flex between>
                    <div>
                      <h4>{item.label}</h4>
                      {item.description && (
                        <div className="text-dark-50 small mt-1">
                          {item.description}
                        </div>
                      )}
                      <div className="text-dark-75 small mt-1">
                        {item.shipname && (
                          <span className="mr-2 text-dark-50">
                            {item.shipname}
                          </span>
                        )}
                        {item.created && (
                          <span className="mr-2">
                            Создан: {created.toLocaleDateString()}
                          </span>
                        )}
                        {item.lastupdate && (
                          <span className="mr-2">
                            Изменен: {lastupdate.toLocaleDateString()}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="text-right">
                      {item.validtodate && (
                        <div>
                          Действует до:
                          <h6>{validtodate.toLocaleDateString()}</h6>
                        </div>
                      )}
                      <div className="d-flex align-items-center justify-content-end text-right">
                        <EssenceStateLabel
                          stateCode={item.statetypecode}
                          stateLabel={item.statelabel}
                          essence="certificate"
                          id={item.id}
                        />
                        {rights.manage && (
                          <EssenceActionsDropdown
                            essence={"certificate"}
                            key={item.id}
                            id={item.id}
                            label={item.label}
                            onFinish={() => this.load()}
                          />
                        )}
                      </div>
                    </div>
                  </Flex>
                </div>
              </div>
              {!this.state.singleFile ? (
                <DefaultNotFound message="Не удалось получить файл" />
              ) : (
                <>
                  {this.state.singleFile && this.state.singleFile.isPdf ? (
                    <>
                      <LibraryPdfView
                        downloadClick={() =>
                          this.download(this.state.singleFile.file)
                        }
                        base64={this.state.singleFile.src}
                      />
                    </>
                  ) : (
                    <>
                      <div className="card card-custom mb-5">
                        <div className="card-body">
                          <h5 className="mb-5">
                            Документ можно только скачать:
                          </h5>
                          {filesList}
                        </div>
                      </div>
                    </>
                  )}
                </>
              )}
            </>
          )}
        </Blocker>
      </>
    );
  }
}
